import {
  post,
  get, // remove
} from 'src/tools/server';

export const getCustomersInSalesChannel = (body) => {
  return post<any>(`/portal/customer/inSalesChannel`, body, {});
};
export const getTagsInSalesChannel = (uuid) => {
  return get(`/portal/customer/tag/inSalesChannel/${uuid}`, {});
};
